/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useEffect, useRef, useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import AnimatedButton from '../../../../components/Animation/AnimatedButton';
import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick';
import { Link } from 'react-router-dom';
import DeviceTemplateExportFn from '../Export';
import { useDeleteDeviceTemplateMutation, useGetDeviceTemplatesQuery } from '../../../../features/deviceTemplateSlice';
import GlobalContext from '../../../../components/Context/GloablContext';
import {useGetHelpGuideAdminQuery} from '../../../../features/patientSlice'
import HelpGuideModal from '../../../../components/HelpGuideModal';
import { handleSidebarPrvState } from '../../../../redux/systemConfigSlice';

const ManageDeviceTemplateTopBar = ({
    title,
    path,
    pathPlaceholder,
    AddButton,
    menuBar,
    buttonName,
    isColumnSelect,
    setIsColumnSelect,
    exportCols,
    username,
    handleMultiRowDelete,
    setMultiDelete,
    isChangeStatusOPen,
    setIsChangeStatusOpen,
    totalPageNumber,
    exportDeviceTemplate, 
    isIdexport,
    data,
    SearchInput

}) => {

    const { setToastmessage, Toastmessage, toastErrorMessage, setToastErrorMessage, isSideBar,setIsSideBar ,isAdvancedSearchOpen , setIsAdvancedSearchOpen} = useContext(GlobalContext);

    const [deleteDeviceTemplates] = useDeleteDeviceTemplateMutation()
    const dispatch = useDispatch()
    const [searchParams, setSearchParams] = useSearchParams()
    const outSideClick = useRef();
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [isHover, setIsHover] = useState(false)
    const selectedRows = useSelector(state => state?.MultiSelectSlice?.selectedRows?.selectedIds)
    const ref = useRef()
    const [deleteLoading, setDeleteLoading] = useState(false)
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    
    
    
    useEffect(() => {
        if (userType === 'corporate-user') {
            setQueryParamsadmin('type=corporate-list-device-template');
        } else {
            setQueryParamsadmin('type=admin-list-device-templates');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);
    
    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false)
    })

    useOnClickOutside(ref, () => {
        setIsChangeStatusOpen(false)
    })

    // Function to handle onClick logic
    const handleSearchClick = () => {            
        // Store the current isSideBar state in Redux
        dispatch(handleSidebarPrvState(isSideBar));
      
        // Update the states after storing the previous state
        setIsAdvancedSearchOpen(true);
        setIsSideBar(false);
    };



    return (
        <div className="flex justify-between items-center mb-[14px]">
            <div className='flex  items-center min-w-fit'>
                {title !== undefined ?
                    <h1 className="text-xl font-normal text-[#000000] 2xl:self-center 2xl:pt-0 pt-2 self-start min-w-fit">{title}</h1>
                    :
                    pathPlaceholder &&
                    <Link to={path} state={username && path !== '/manage-admin-corporate/' ? [username] : null} className='hidden items-center min-w-max xl:flex'>
                        <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                        <span className='text-sm font-normal text-[#008586] ml-3'>{pathPlaceholder}</span>
                    </Link>
                }
                {
                    userType !=='super-admin' &&
                    <span   onClick={() => setHelpGuideModel(true)} className=' ml-2 cursor-pointer'>
                        <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                    </span> 
                }

            </div>
            
            <div className="flex items-center w-fit justify-end relative 2xl:flex-nowrap flex-wrap">
                {menuBar && <div className='relative'>
                    <button id="threedot" className={`rounded-[15px] border border-[#972E4C] px-[13px] py-[10px] mr-2.5 2xl:mb-0 mb-2.5 hover:bg-[#972E4C] focus:bg-[#972E4C] ${isChangeStatusOPen ? 'bg-[#972E4C]' : 'bg[#1111]'}`}
                        onClick={() => { setIsChangeStatusOpen(!isChangeStatusOPen),setIsFilterOpen!==undefined&&setIsFilterOpen(false) }}
                        onMouseEnter={() => setIsHover(true)}
                        onMouseLeave={() => setIsHover(false)}
                    >
                        {
                            isHover || isChangeStatusOPen ? <img src="/images/3dots_white.svg" alt="img" /> : <img src="/images/3_dots_color.svg" alt="img" />
                        }
                    </button>
                    {isChangeStatusOPen && <ul ref={ref} className='px-1.5 py-3 rounded-[6px] absolute top-12 right-5 bg-[#fff] min-w-[202px] shadow-s3 z-[2] '>
                        <li className='pl-3 pr-[9px] py-1 text-base font-bold text-[#972E4C] mb-2'>Delete Template</li>
                        <li>
                            <ul>
                                <li>
                                    <AnimatedButton
                                        handleClick={(e) => {setMultiDelete(true) , setIsChangeStatusOpen(false) }}
                                        buttonName={"Delete"}
                                        disabled={deleteLoading}
                                        className={`pl-3 pr-[9px] py-1 mb-2 text-base font-normal   hover:text-[#6e6d6d] text-[#000000] cursor-pointer'} `} />
                                </li>
                            </ul>
                        </li>
                    </ul>}
                </div>}
                {SearchInput && <button id='search-btn' onClick={handleSearchClick} className="ml-2.5 2xl:mb-0 mb-2.5 border border-[#972E4C] rounded-[15px] px-[13px] py-[13px]">
                    <img loading='lazy' decoding='async' src="/images/search_red.svg" alt="icon" className=''/>
                </button>}
                {data && data.total_count > 0 && <div>
                    <DeviceTemplateExportFn
                        selectedRows={selectedRows}
                        exportDeviceTemplate={exportDeviceTemplate}
                        setIsFilterOpen={setIsFilterOpen}
                        exportCols={exportCols}
                        isColumnSelect={isColumnSelect}
                        setIsColumnSelect={setIsColumnSelect}
                        isIdexport={isIdexport} username={username} />
                </div>}
                {AddButton &&
                    <>{<Link to={path} state={{ "limit": searchParams.get("limit"), "page_number": searchParams.get("page_number"),"search_mode": searchParams.get("search_mode"), 'search': searchParams.get("search") ? searchParams.get("search") : '' }}>
                        <button type='button'
                            id="Add user"
                            className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] rounded-[16px] ml-2.5 2xl:mb-0 mb-2.5 
                                bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]`}>
                            <span className="mr-2.5"><img src="/images/add_Icon_white.svg" alt="img" /></span>
                            {buttonName}
                        </button>
                    </Link>}</>}
                {(helpGuideModel && helpguidestatus==="fulfilled") &&
                    <HelpGuideModal
                        setHelpGuideModel={setHelpGuideModel}
                        pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                    />
                }
            </div>
        </div>
    );
}

export default ManageDeviceTemplateTopBar;
